import { css } from '@emotion/react';
import React, { memo } from 'react';
import isEmpty from 'lodash/isEmpty';
import { globalGreen, globalRed } from '~/modules/AppLayout/Colors';
import { flex } from '~/modules/AppLayout/FlexGridCss';
import { useTradingSummaryState } from '~/modules/tradeSheet/tradingSummary/useTradingSummaryState';
import { tradeLabelCss, rankingSubtitleCss, topThreeWrapperCss, topThreeBoxCss, topThreeSectionCss, rankingTitleCss, } from '~/modules/tradeSheet/tradingSummary/tradingSummaryCss';
import { RankingDivider } from '~/modules/tradeSheet/tradingSummary/tradingStyleComponent';
const EMPTY_STATUS = (<h4 css={css `
      height: 100%;
      ${flex.v.allCenter};
    `}>
    尚無資訊
  </h4>);
const TopThreeProfit = memo(function TopThreeProfit(props) {
    const { state } = useTradingSummaryState.useContainer();
    const { top3PnL } = state;
    const data = top3PnL && top3PnL[0] ? top3PnL[0] : null;
    return (<div css={topThreeWrapperCss}>
      <p css={tradeLabelCss(globalRed.r500)}>前三大獲利產品及其報酬金額</p>
      {!data || (isEmpty(data.winStock1) && isEmpty(data.winStock2) && isEmpty(data.winStock3)) ? (EMPTY_STATUS) : (<>
          <p css={rankingSubtitleCss(globalRed.r500)}>
            <RankingDivider color={globalRed.r500}/>
            <span css={rankingTitleCss}>獲利TOP3</span>
            <RankingDivider color={globalRed.r500}/>
          </p>
          <div css={topThreeBoxCss}>
            {data?.winStock1 && (<div css={topThreeSectionCss}>
                <p>{data?.winStock1}</p>
                <p>$ {USPriceFormat(data?.profit1)}</p>
              </div>)}
            {data?.winStock2 && (<div css={topThreeSectionCss}>
                <p>{data?.winStock2}</p>
                <p>$ {USPriceFormat(data?.profit2)}</p>
              </div>)}
            {data?.winStock3 && (<div css={topThreeSectionCss}>
                <p>{data?.winStock3}</p>
                <p>$ {USPriceFormat(data?.profit3)}</p>
              </div>)}
          </div>
        </>)}
    </div>);
});
const TopThreeLoss = memo(function TopThreeLoss() {
    const { state } = useTradingSummaryState.useContainer();
    const { top3PnL } = state;
    const data = top3PnL && top3PnL[0] ? top3PnL[0] : null;
    return (<div css={topThreeWrapperCss}>
      <p css={tradeLabelCss(globalGreen.g400)}>前三大虧損產品及其報酬金額</p>

      {!data ||
            (isEmpty(data.loseStock1) && isEmpty(data.loseStock2) && isEmpty(data.loseStock3)) ? (EMPTY_STATUS) : (<>
          <p css={rankingSubtitleCss(globalGreen.g400)}>
            <RankingDivider color={globalGreen.g400}/>
            <span css={rankingTitleCss}>虧損TOP3</span>
            <RankingDivider color={globalGreen.g400}/>
          </p>
          <div css={topThreeBoxCss}>
            {data?.loseStock1 && (<div css={topThreeSectionCss}>
                <p>{data?.loseStock1}</p>
                <p>$ {USPriceFormat(data?.loss1)}</p>
              </div>)}
            {data?.loseStock2 && (<div css={topThreeSectionCss}>
                <p>{data?.loseStock2}</p>
                <p>$ {USPriceFormat(data?.loss2)}</p>
              </div>)}
            {data?.loseStock3 && (<div css={topThreeSectionCss}>
                <p>{data?.loseStock3}</p>
                <p>$ {USPriceFormat(data?.loss3)}</p>
              </div>)}
          </div>
        </>)}
    </div>);
});
const USPriceFormat = (n) => {
    const isNegative = n < 0;
    const strNum = Math.abs(n).toString();
    const numberNFloat = strNum.split('.');
    const reversedN = numberNFloat[0].split('').reverse();
    const reverseReversedN = reversedN
        .map((charNum, index) => index !== reversedN.length - 1 && (index + 1) % 3 === 0 ? `,${charNum}` : charNum)
        .reverse()
        .join('');
    return `${isNegative ? '-' : ''}${reverseReversedN}${numberNFloat[1] ? /*`.${numberNFloat[1]}`*/ '' : ''}`;
};
export default { Profit: TopThreeProfit, Loss: TopThreeLoss };
